export default __webpack_public_path__ + "static/media/unimedLogo.4999fc94.png";